/* QABAS v1.2.1 — URL propres : pas de ?variant=123456 dans la barre d'adresse */
(function () {
  if (!window.history || !history.replaceState || !window.URL) return;
  var orig = history.replaceState.bind(history);
  var clean = function (url) {
    try {
      var u = new URL(url, window.location.href);
      if (!u.searchParams.has('variant')) return url;
      u.searchParams.delete('variant');
      return u.pathname + u.search + u.hash;
    } catch (e) { return url; }
  };
  history.replaceState = function (state, title, url) {
    return orig(state, title, url == null ? url : clean(url));
  };
  if (window.location.search.indexOf('variant=') > -1) {
    orig(history.state, '', clean(window.location.href));
  }
})();

/* QABAS v1.2 — l'image suit la couleur choisie (produit en vedette + fiche produit mobile) */
(function () {
  function findVariant(box) {
    var json = box.querySelector('[data-product-json]');
    if (!json) return null;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return null; }
    if (!product || !product.variants) return null;
    var selected = Array.prototype.map.call(box.querySelectorAll('fieldset.opt'), function (fs) {
      var c = fs.querySelector('input:checked'); return c ? c.value : null;
    });
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    }) || null;
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest ? e.target.closest('.opt__input') : null;
    if (!input) return;
    var box = input.closest('[data-product-buy]');
    var section = box && box.closest('.shopify-section');
    if (!section) return;
    var variant = findVariant(box);
    if (!variant || !variant.featured_media) return;
    var id = variant.featured_media.id;

    // Produit en vedette (page d'accueil)
    var stack = section.querySelector('.fp__stack--variants');
    if (stack) {
      var target = stack.querySelector('[data-media-id="' + id + '"]');
      if (target) {
        Array.prototype.forEach.call(stack.querySelectorAll('.fp__img'), function (el) {
          el.classList.toggle('is-active', el === target);
        });
      }
    }

    // Fiche produit : carrousel mobile
    var track = section.querySelector('.pdp__track');
    if (track && window.innerWidth < 990) {
      var media = track.querySelector('[data-media-id="' + id + '"]');
      if (media) {
        setTimeout(function () {
          var left = media.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
          track.scrollTo({ left: left, behavior: 'smooth' });
        }, 60);
      }
    }
  });
})();
